import { IPeriodDate } from "src/app/action-history-queue/interfaces/date-range.interface";
import moment from 'moment';

export function listRangeDates(): IPeriodDate[] {
  return [{
    range: {
      initialDate: '',
      endDate: ''
    },
    label: "Selecione um período"
  }, {
    range: {
      initialDate: '',
      endDate: ''
    },
    label: "Personalizado"
  }, {
    range: {
      initialDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    },
    label: "Hoje"
  }, {
    range: {
      initialDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      endDate: moment().subtract(1, 'days').format('YYYY-MM-DD')
    },
    label: "Ontem"
  }, {
    range: {
      initialDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    },
    label: "Últimos 7 dias"
  }, {
    range: {
      initialDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    },
    label: "Último mês"
  }, {
    range: {
      initialDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    },
    label: "Último ano"
  }];
}